import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import InstallPage from "@/pages/InstallPage";
import DashboardPage from "@/pages/DashboardPage";
import ProductEditorPage from "@/pages/ProductEditorPage";
import SettingsPage from "@/pages/SettingsPage";
import OnboardingPage from "@/pages/OnboardingPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import WidgetPage from "@/pages/WidgetPage";
import PrivacyPage from "@/pages/PrivacyPage";
import SupportPage from "@/pages/SupportPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OnboardingPage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/product/:productId" element={<ProductEditorPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/widget" element={<WidgetPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;